module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_primaerlogo_oslo_viken_neg.28982512.svg";